import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

import Tab from './elements/Tab';

class TabContent extends Component {
  state = {
    activeIndex: 0,
    offsetTop: [],
  };

  componentDidMount() {
    const offsetTop = this.props.tabData.map(
      item => document.getElementById(item.title).offsetTop
    );
    this.setState({ offsetTop });
  }

  handleIndex = index => {
    const offsetTop = this.props.tabData.map(
      item => document.getElementById(item.title).offsetTop
    );
    this.setState({ activeIndex: index, offsetTop });
  };

  render() {
    const { tabData } = this.props;
    return (
      <Root {...this.props}>
        <Options
          index={this.state.activeIndex}
          totalTabs={tabData.length}
          activeIndex={this.state.activeIndex}
          offsetTop={this.state.offsetTop[this.state.activeIndex]}
        >
          {tabData.map((tab, index) => (
            <div key={index} id={tab.title}>
              <Tab
                title={tab.title}
                handleIndex={this.handleIndex}
                index={index}
                current={index === this.state.activeIndex}
              />
              <MobileContent shown={index === this.state.activeIndex}>
                {tab.data}
              </MobileContent>
            </div>
          ))}
        </Options>
        <Content key={this.state.activeIndex}>
          {tabData[this.state.activeIndex].data}
        </Content>
      </Root>
    );
  }
}

export default TabContent;

TabContent.propTypes = {
  tabData: PropTypes.array,
};

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 40px auto 0;
  @media (min-width: ${media.smup}) {
    min-height: 377px;
  }
  @media (min-width: ${media.lgup}) {
    width: 60%;
  }
`;

const Options = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
  @media (min-width: ${media.smup}) {
    width: 45%;
  }
  &::before {
    content: '';
    width: 4px;
    height: ${props => `calc(100% / ${props.totalTabs} / 2)`};
    transform: translateY(50%);
    background-color: black;
    transition: 0.3s ease;
    position: absolute;
    left: 0;
    /* top: ${props =>
      `calc(calc(100% / ${props.totalTabs}) * ${props.index})`}; */
    top: ${props => props.offsetTop}px;
    display: none;
    @media (min-width: ${media.smup}) {
      display: block;
    }
  }
`;

const fadeContent = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
`;

const Content = styled.div`
  width: 50%;
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 18px;
  color: rgba(0, 0, 0, 0.72);
  letter-spacing: 0;
  line-height: 24px;
  animation: ${fadeContent} 0.5s ease;
  display: none;
  @media (min-width: ${media.smup}) {
    display: block;
  }
  img {
    display: block;
    margin-bottom: 20px;
  }
`;

const slideContent = keyframes`
  0% {
    max-height: 0;
  }
  100% {
    max-height: 700px;
  }
`;

const MobileContent = styled.div`
  display: ${props => (props.shown ? 'block' : 'none')};
  animation: ${slideContent} 1s ease;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 18px;
  color: rgba(0, 0, 0, 0.72);
  letter-spacing: 0;
  line-height: 24px;
  @media (min-width: ${media.smup}) {
    display: none;
  }
  img {
    display: block;
    margin-bottom: 20px;
  }
  li {
    list-style-type: none;
    margin-bottom: 10px;
    margin-left: 1em;
    &::before {
      content: '•';
      color: ${({ theme }) => theme.colorPrimary};
      display: inline-block;
      width: 1em;
      margin-left: -1em;
    }
  }
  ul {
    margin: 20px 0;
    @media (min-width: ${media.smup}) {
      margin-top: 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/TabContent/TabContent.js